import type { CreditPolicy } from '../../types/domain';

export const PHASE9_DATABASE_KEY = 'nexo.phase9.collections.database';

export const DEFAULT_CREDIT_POLICY: CreditPolicy = {
  defaultDueDays: 30,
  overdueGraceDays: 0,
  blockNewCreditWithOverdue: true,
  allowCreditWithoutLimit: false,
  warnAtUtilizationPercent: 80,
};

export function getCreditPolicy(businessId: string): CreditPolicy {
  try {
    const raw = localStorage.getItem(PHASE9_DATABASE_KEY);
    if (!raw) return DEFAULT_CREDIT_POLICY;
    const parsed = JSON.parse(raw) as { businesses?: Record<string, { creditPolicy?: CreditPolicy }> };
    return { ...DEFAULT_CREDIT_POLICY, ...(parsed.businesses?.[businessId]?.creditPolicy ?? {}) };
  } catch {
    return DEFAULT_CREDIT_POLICY;
  }
}
